'use client';

import { ReactNode } from 'react';

interface ShiftKeyTooltipProps {
  children: ReactNode;
  shortcut: string;
  description?: string;
  show: boolean;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export function ShiftKeyTooltip({ 
  children, 
  shortcut, 
  show, 
  position = 'top' 
}: ShiftKeyTooltipProps) {
  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };

  const arrowClasses = {
    top: 'top-full left-1/2 transform -translate-x-1/2 border-l-transparent border-r-transparent border-b-transparent border-t-orange-600',
    bottom: 'bottom-full left-1/2 transform -translate-x-1/2 border-l-transparent border-r-transparent border-t-transparent border-b-orange-600',
    left: 'left-full top-1/2 transform -translate-y-1/2 border-t-transparent border-b-transparent border-r-transparent border-l-orange-600',
    right: 'right-full top-1/2 transform -translate-y-1/2 border-t-transparent border-b-transparent border-l-transparent border-r-orange-600'
  };

  return (
    <div className="relative inline-block">
      {children}
      {show && (
        <div className={`absolute z-[60] ${positionClasses[position]} animate-in fade-in-0 zoom-in-95 duration-150`}>
          <div className="bg-orange-600 text-white px-2 py-1 rounded-lg shadow-lg border border-orange-700">
            <div className="flex items-center justify-center whitespace-nowrap font-mono text-sm font-bold min-w-[24px] h-6">
              {shortcut}
            </div>
          </div>
          {/* Arrow */}
          <div className={`absolute w-0 h-0 border-4 ${arrowClasses[position]}`} />
        </div>
      )}
    </div>
  );
}